import { __rest } from "tslib";
import React, { Children } from 'react';
import { connectField, joinName } from 'uniforms';
import AutoField from './AutoField';
import ListDelField from './ListDelField';
const ListItem = (_a) => {
    var { removeIcon } = _a, props = __rest(_a, ["removeIcon"]);
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "col-1" },
            React.createElement(ListDelField, { name: props.name, removeIcon: removeIcon })),
        props.children ? (Children.map(props.children, child => React.cloneElement(child, {
            className: 'col-11',
            name: joinName(props.name, child.props.name),
            label: null,
        }))) : (React.createElement(AutoField, Object.assign({}, props, { className: "col-11" })))));
};
export default connectField(ListItem, {
    includeInChain: false,
    includeParent: true,
});
